type SellerFitmentIconProps = {
  className?: string;
  fill?: string;
};

export default function SellerFitmentIcon({
  className,
  fill = '#C41819',
}: SellerFitmentIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Red circle */}
      <circle cx="12" cy="12" r="11" fill={fill} />
      {/* White exclamation mark */}
      <text
        x="12"
        y="17"
        textAnchor="middle"
        fill="white"
        fontSize="16"
        fontWeight="bold"
        fontFamily="Arial, sans-serif"
      >
        !
      </text>
    </svg>
  );
}
